import { getPlatformList } from '@/services/menu/MenuController';
import { addRole, delRole, editRole, getMenuList, getRoleList, getRoleMenuList } from '@/services/role/RoleController';
import { ActionType } from '@ant-design/pro-components';
import { useRequest } from 'ahooks';
import { debounce } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';

export default () => {
  const actionRef = useRef<ActionType>();
  const [loading, setLoading] = useState(false);
  const [platformId, setPlatformId] = useState<number>(1);
  /** 新增角色**/
  const insertRole = useRequest(addRole, {
    manual: true,
  });
  /** 更新角色**/
  const updateRole = useRequest(editRole, {
    manual: true,
  });
  /** 更新角色**/
  const deleteRole = useRequest(delRole, {
    manual: true,
  });
  /** 获取对应平台的角色列表**/
  const fetchRoleList = useRequest(getRoleList, {
    manual: true,
  });
  /** 获取平台列表**/
  const fetchPlatformList = useRequest(getPlatformList, {
    manual: true,
  });
  /** 获取对应平台的菜单列表**/
  const fetchMenuList = useRequest(getMenuList, {
    manual: true,
  });
  /** 获取对应角色绑定的菜单列表**/
  const fetchRoleMenuList = useRequest(getRoleMenuList, {
    manual: true,
  });

  /**
   *  需要监听Loading状态的方法
   *  仅 useRequest 返回的函数可以录入
   */
  const effectLoadingList = [
    insertRole,
    updateRole,
    fetchRoleList,
    fetchPlatformList,
    fetchMenuList,
    fetchRoleMenuList,
    deleteRole,
  ];
  /**
   * 监听处理loading状态
   */
  useEffect(() => {
    // 防抖处理的函数，延迟500ms后执行setLoading
    const debouncedSetLoading = debounce((loading: boolean) => {
      setLoading(loading);
    }, 200);
    const bool = effectLoadingList.some((item) => {
      return item.loading;
    });
    debouncedSetLoading(bool);
    // 清理防抖函数
    return () => {
      debouncedSetLoading.cancel();
    };
  }, effectLoadingList);

  return {
    actionRef,
    platformId,
    setPlatformId,
    loading,
    setLoading,
    insertRole,
    updateRole,
    fetchRoleList,
    fetchPlatformList,
    fetchMenuList,
    fetchRoleMenuList,
    deleteRole,
  };
};
